"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceItem = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = require("styled-components");
const choice_item_styled_1 = require("./choice-item.styled");
const Close = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/close'))));
const ChoiceItem = ({ label, index, clearCb, isFocused, testId = 'choiceItem', }) => {
    const theme = (0, styled_components_1.useTheme)();
    const cleartItemHandler = () => {
        clearCb(index);
    };
    return (react_1.default.createElement(choice_item_styled_1.ChoiceItemContainer, { isFocused: isFocused, "data-testid": `${testId}.${index}` },
        label,
        react_1.default.createElement(choice_item_styled_1.ChoiceItemControl, { onClick: cleartItemHandler },
            react_1.default.createElement(react_1.Suspense, { fallback: null },
                react_1.default.createElement(Close, { width: 16, color: theme.colors.icon.quaternary })))));
};
exports.ChoiceItem = ChoiceItem;
